export default __webpack_public_path__ + "static/media/hht1_home_img_EP18.242e94f0.png";